import { enqueueSnackbar } from "notistack";

export const notifySnackbar = (text, variant = "success", options) => {
  enqueueSnackbar(text, { variant, ...options });
};
